import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './core/Auth';

export function Logout() {
  const { logout } = useAuth();
  useEffect(() => {
    logout();
    document.location.reload();
  }, [logout]);

  // A bare <Navigate> — react-router 6.30 rejects it as a direct child of <Routes>, which
  // crashed this screen before the logout effect could run.
  return <Navigate to='/auth/login' />;
}
